import PipeEdge from "./PipeEdge";
import WidgetConnector from "../widgets/WidgetConnector";

/**
 * Edge type registry for React Flow.
 *
 * - `pipe` – SCADA industrial pipe connection with animated flow
 * - `widgetConnector` – Dashed connector between node and its floating widget
 *
 * Future milestones may add: conduit, cable, signal, etc.
 */
const edgeTypes = {
  pipe: PipeEdge,
  widgetConnector: WidgetConnector,
};

export default edgeTypes;
